import OneTouristGroupByRoomTours from './OneTouristGroupByRoomTours';

const TouristGroupedByRoomTours = ({
  row,
  hideoperator = false,
  row_fix,
  request_model,
  likes,
  carts,
  setTourToShare,
  setOpenModal,
  roomList,
  groupedTours,
  setTourToCart,
  setTourLike,
  handleOfficeSave,
}) => {
  return roomList.map((room) => (
    <OneTouristGroupByRoomTours
      key={room}
      row={row}
      room={room}
      hideoperator={hideoperator}
      row_fix={row_fix}
      request_model={request_model}
      likes={likes}
      carts={carts}
      setTourToShare={setTourToShare}
      setOpenModal={setOpenModal}
      groupedTours={groupedTours}
      setTourToCart={setTourToCart}
      setTourLike={setTourLike}
      handleOfficeSave={handleOfficeSave}
    />
  ));
};

export default TouristGroupedByRoomTours;
